import React from 'react';
import './YelpSection.css';

function Stars({ rating }) {
  const full = Math.round(rating);
  return (
    <span className="yelp-stars" aria-label={`${rating} stars`}>
      {'★'.repeat(full)}{'☆'.repeat(5 - full)}
    </span>
  );
}

const YelpSection = ({ restaurant }) => {
  if (!restaurant) return null;

  const reviews = (restaurant.reviews ?? []).filter((r) => r.id);

  return (
    <section className="yelp-section">
      <h3 className="yelp-heading">Yelp Reviews</h3>

      <div className="yelp-rating-row">
        <Stars rating={restaurant.rating} />
        <span className="yelp-rating-label">
          {restaurant.rating} · {restaurant.reviewCount?.toLocaleString()} reviews
        </span>
      </div>

      {reviews.map((review) => (
        <blockquote key={review.id} className="yelp-review">
          <p>{review.text}</p>
          <footer>— {review.user}</footer>
        </blockquote>
      ))}

      {restaurant.yelpUrl && (
        <a className="yelp-link" href={restaurant.yelpUrl} target="_blank" rel="noopener noreferrer">
          See all reviews on Yelp ↗
        </a>
      )}
    </section>
  );
};

export default YelpSection;
